export default {"src":"/_next/static/media/glow-top.b910cff3.svg","height":658,"width":1404,"blurWidth":0,"blurHeight":0};